function isClickOutside(el, event) {
  return !(el === event.target || el.contains(event.target));
}

export default {
  mounted(el, binding) {
    el.__clickOutsideHandler__ = (event) => {
      if (isClickOutside(el, event)) {
        binding.value(event);
      }
    };

    document.addEventListener("click", el.__clickOutsideHandler__);
    document.addEventListener("touchstart", el.__clickOutsideHandler__);
  },

  unmounted(el) {
    document.removeEventListener("click", el.__clickOutsideHandler__);
    document.removeEventListener("touchstart", el.__clickOutsideHandler__);
    delete el.__clickOutsideHandler__;
  },
};
